<template>
  <div>
    <div class="invoice-basic">
      <div class="plane">
        <div>
          <p>发票号码</p>
          <p>开票日期</p>
          <p>{{invoiceInfo.invoiceNo || invoiceInfo.ocrInvoiceNo}}</p>
          <p>{{invoiceInfo.drewDate || invoiceInfo.ocrDrewDate}}</p>
        </div>
        <div>
            <p>出发站</p>
            <p></p>
            <p>航班</p>
            <p></p>
            <p>到达站</p>
            <p>{{invoiceInfo.detailList && invoiceInfo.detailList[0] ? invoiceInfo.detailList[0].flyFrom : ''}}</p>
            <p>{{invoiceInfo.detailList && invoiceInfo.detailList[0] ? invoiceInfo.detailList[0].flightNumber : ''}}</p>
            <p>{{invoiceInfo.detailList && invoiceInfo.detailList[0] ? invoiceInfo.detailList[invoiceInfo.detailList.length - 1].flyTo : ''}}</p>
        </div>
      </div>
      <van-divider dashed />
      <van-cell-group v-if="invoiceInfo.detailList && invoiceInfo.detailList.length" :border="false">
        <van-field
          label="客票号码"
        >
          <p slot="input" class="input">{{invoiceInfo.detailList[0].ticketId}}</p>
        </van-field>
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.checkCode" :border="false">
        <van-field
          :label="invoiceInfo.invoiceType === '202' ? '验证码' : '校验码'"
        >
          <p slot="input" class="input">{{invoiceInfo.checkCode}}</p>
        </van-field>
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.ocrAmountWithTax || invoiceInfo.amountWithTax" :border="false">
        <van-field
          label="发票金额"
        >
          <p slot="input" class="input" style="color: #2196F3;font-weight:bold">{{convertNumber(invoiceInfo.ocrAmountWithTax || invoiceInfo.amountWithTax)}}</p>
        </van-field>
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.taxAmount" :border="false">
        <van-field
          label="发票税额"
        >
          <p slot="input" class="input" style="color: #2196F3;font-weight:bold">{{convertNumber(invoiceInfo.taxAmount)}}</p>
        </van-field>
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.passengerName" :border="false">
        <van-field
          label="乘客姓名"
        >
          <p slot="input" class="input">{{invoiceInfo.passengerName}}</p>
        </van-field>
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.caacDevelopmentFund" :border="false">
        <van-field
          label="民航发展基金"
        >
          <p slot="input" class="input">{{invoiceInfo.caacDevelopmentFund}}</p>
        </van-field>
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.caacDevelopmentFund" :border="false">
        <van-field
          label="燃油附加费"
        >
          <p slot="input" class="input">{{invoiceInfo.fuelSurcharge}}</p>
        </van-field>
      </van-cell-group>
    </div>
    <van-divider dashed />
    <van-cell-group :border="false">
      <van-field
        label="备注"
      >
        <div slot="input" class="input">{{invoiceInfo.remark}}</div>
      </van-field>
    </van-cell-group>
    <van-cell-group :border="false">
      <van-field
        label="标签"
      >
        <div slot="input" class="input">{{invoiceInfo.tag}}</div>
      </van-field>
    </van-cell-group>
  </div>
</template>

<script>
import {
  CellGroup,
  Field,
  Divider
} from 'vant'
import { ConvertNumber } from '@utils/basicUtil'
export default {
  props: {
    invoiceInfo: {
      type: Object
    }
  },
  mounted () {
  },
  methods: {
    convertNumber (data) {
      return ConvertNumber(data)
    }
  },
  components: {
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Divider.name]: Divider
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
